module.exports = __webpack_public_path__ + "img/carts.92f3e182.png";